/**
 * Cloudflare Image Resizing & Delivery Utilities for Auxo Asset CDN
 * Resizes on-the-fly, enforces format=auto (AVIF/WebP) and target dimensions.
 */

export function getOptimizedImageUrl(url, { width = 800, quality = 80, format = 'auto' } = {}) {
  if (!url || typeof url !== 'string') return url;
  if (!url.startsWith('https://assets.auxodev.dk/')) return url;
  if (url.includes('/cdn-cgi/image/')) return url;
  if (url.endsWith('.svg') || url.endsWith('.ico')) return url;

  const path = url.replace('https://assets.auxodev.dk/', '');
  return `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=${format}/${path}`;
}

export function getImageSrcSet(url, widths = [400, 800, 1200], quality = 80) {
  if (!url || typeof url !== 'string') return undefined;
  if (!url.startsWith('https://assets.auxodev.dk/')) return undefined;
  if (url.endsWith('.svg') || url.endsWith('.ico')) return undefined;

  return widths
    .map((w) => `${getOptimizedImageUrl(url, { width: w, quality })} ${w}w`)
    .join(', ');
}
